import { Config } from '@Config/Config';
import { Experiments } from '@Config/Experiments';
import { Features } from '@Config/Features';

type EventData = {
  eventKey: string;
  eventTags?: string[];
};

export function trackDataLayerEvent(event: string): void {
  try {
    // @ts-ignore
    window.dataLayer.push({ event });
  } catch (e) {
    console.log('datalayer not logged');
  }
}

export function trackAbTestEvent(eventKey: string, eventTags?: string[]): void {
  const data: EventData = {
    eventKey,
    eventTags
  };
  const blob: Blob = new Blob([JSON.stringify(data)], {
    type: 'application/json;charset=UTF-8'
  });

  //TODO we should have a fallback
  if (!navigator.sendBeacon) return;

  navigator.sendBeacon(getTrackingUrl(Config.tenant, Config.coreShopEnvironment, Config.language), blob);
}

export function activateExperimentViaFock(featureKeys: string[] | Experiments[]): void {
  fetch(getActivationUrl(Config.tenant, Config.coreShopEnvironment, Config.language), {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify({
      featureKeys
    })
  });
}

function getTrackingUrl(tenant: string, coreShopEnvironment: string, language: string): string {
  return `/webclient/experiments/${createTenantPath(tenant, coreShopEnvironment)}/${language}/track`;
}

function getActivationUrl(tenant: string, coreShopEnvironment: string, language: string): string {
  return `/webclient/experiments/${createTenantPath(tenant, coreShopEnvironment)}/${language}/activate`;
}

function createTenantPath(tenant: string, coreShopEnvironment: string): string {
  return coreShopEnvironment === 'prod' ? tenant : `${tenant}-${coreShopEnvironment}`;
}
